<template>
  <button
    class="btn btn-outline-light btn-my-list px-3"
    @click.stop="isAdded ? removeFromList() : addToList()"
    :style="`color:${color};`"
    :class="{ hoverClass, isAdded: isAdded }"
  >
    <loading :show="loading" small>
      <i
        :class="{
          'icon-checkmark': isAdded,
          'icon-plus': !isAdded,
          'me-2': !isShort,
        }"
      />
      <span v-if="!isShort">Minha lista</span>
    </loading>
  </button>
</template>

<script>
  import { mapState } from "vuex";

  export default {
    props: {
      item: {
        type: Object,
        required: true,
      },
      color: {
        type: String,
        required: false,
        default: "#fff",
      },
      hoverClass: {
        type: String,
        required: false,
        default: "transition-scale",
      },
      isConference: {
        type: Boolean,
        default: false,
      },
      isLibrary: {
        type: Boolean,
        default: false,
      },
      isShort: {
        type: [Boolean, Number],
        default: false,
        validator: function (value) {
          return typeof value === "boolean" || typeof value === "number";
        },
      },
    },
    data() {
      let action,
        removeAction,
        updateAction = "";

      if (this.isConference) {
        action = "conferences/addToMyList";
        removeAction = "conferences/removeToMyList";
        updateAction = "conferences/getMyList";
      } else if (this.isLibrary) {
        action = "library/addToMyList";
        removeAction = "library/removeToMyList";
        updateAction = "library/getMyList";
      } else {
        action = "courses/addToMyList";
        removeAction = "courses/removeToMyList";
        updateAction = "courses/getMyList";
      }

      return {
        loading: false,
        removeAction,
        updateAction,
        action,
      };
    },
    methods: {
      addToList() {
        this.loading = true;
        this.$store.dispatch(this.action, this.item.id).finally(() => {
          this.$store.dispatch(this.updateAction);
          this.loading = false;
        });
      },
      removeFromList() {
        this.loading = true;
        this.$store
          .dispatch(this.removeAction, {
            user_id: this.user.id,
            id: this.item.id,
          })
          .finally(() => {
            this.$store.dispatch(this.updateAction);
            this.loading = false;
          });
      },
    },
    computed: {
      ...mapState("user", ["user"]),
      isAdded() {
        if (this.item?.is_mylist) {
          return 1;
        } else {
          if (this.isConference)
            return this.$store.state.conferences.my_list?.filter(
              (conference) => conference?.id === this.item?.id
            ).length;

          if (this.isLibrary)
            return this.$store.state.library.my_list?.filter(
              (book) => book?.id === this.item?.id
            ).length;

          return this.$store.state.courses.my_list?.filter(
            (course) => course?.id === this.item?.id
          ).length;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .btn-my-list {
    max-width: 149px;
    color: #fff;

    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;

    border-radius: 38px;

    background: none;
    outline: none;

    transition: all 0.5s;

    &.transition-scale {
      &:hover {
        transform: scale(1.1);
      }
    }

    &.isAdded {
      background: #63c98f;
      border: none;
    }
  }
</style>
